import React, { createContext, useContext, useRef, useCallback } from 'react';

const NavigationStateContext = createContext(null);

// In-memory store (NOT localStorage/sessionStorage) so a screen's filters/sort/
// scroll/tab survive a Back/Esc navigation away-and-back within the same
// browser tab session, but reset naturally on a full page reload.
// Must be mounted once, above <Routes>, so it never unmounts on navigation.
export function NavigationStateProvider({ children }) {
  const storeRef = useRef(new Map());

  const getScreenState = useCallback((key, fallback) => {
    return storeRef.current.has(key) ? storeRef.current.get(key) : fallback;
  }, []);

  const setScreenState = useCallback((key, value) => {
    storeRef.current.set(key, value);
  }, []);

  const clearScreenState = useCallback((key) => {
    storeRef.current.delete(key);
  }, []);

  return (
    <NavigationStateContext.Provider value={{ getScreenState, setScreenState, clearScreenState }}>
      {children}
    </NavigationStateContext.Provider>
  );
}

export function useNavigationStateStore() {
  const ctx = useContext(NavigationStateContext);
  if (!ctx) {
    throw new Error('useNavigationStateStore must be used within NavigationStateProvider');
  }
  return ctx;
}
